const autopostulacion = {
  enabled: false,
}

export default autopostulacion
